import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FieldConfig } from '../../field.interface';
@Component({
    selector: 'app-input',
    templateUrl: './input.component.html',
    styles: [],
    standalone: false
})
export class InputComponent implements OnInit {
  field: FieldConfig;
  group: UntypedFormGroup;
  constructor() { }
  ngOnInit() { }
}
